import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';

export type Getters = {
  cameraPos(state: State): number;
}

export const getters: GetterTree<State, RootState> & Getters = {
  cameraPos: (state) => state.cameraPos,
};
